import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestLoginModal } from '@corefront/redux-aba';
import { useQueryGame } from '../../../hooks/API/useQueryGames';
import { isLoggedInSelector } from '../../../redux/reducers/app/params';

export const useRequestLoginModal = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(requestLoginModal());
    }
  }, [dispatch, isLoggedIn]);
};

export const useLaunchPayload = (gameId) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  const { data, status } = useQueryGame(gameId, false, { enabled: isLoggedIn });

  const result = data?.launchPayload ?? null;
  const isReady = status !== 'loading';

  return [result, isReady];
};
